<template>
  <footer class="footer-section">
    <div class="container">
      <div class="footer-main">
        <div class="footer-company">
          <div class="footer-logo">
            <div class="logo-square"></div>
            <span>弦动魔方科技</span>
          </div>
          <p class="company-intro">
            专注于人工智能领域的前沿科技型企业，致力于AI大模型训练、微调定制以及软件应用和硬件应用开发。
          </p>
          
          <div class="social-icons">
            <a href="#" class="social-icon"><i class="fab fa-weixin"></i></a>
            <a href="#" class="social-icon"><i class="fab fa-weibo"></i></a>
            <a href="#" class="social-icon"><i class="fas fa-circle"></i></a>
            <a href="#" class="social-icon"><i class="fab fa-linkedin"></i></a>
          </div>
        </div>
        
        <div class="footer-links-wrapper">
          <div class="footer-column">
            <h3 class="column-title">解决方案</h3>
            <ul class="footer-links">
              <li><a href="#">AI模型</a></li>
              <li><a href="#">微调训练</a></li>
              <li><a href="#">AIGC定制化平台</a></li>
              <li><a href="#">数据标注服务</a></li>
              <li><a href="#">智能硬件开发</a></li>
            </ul>
          </div>
          
          <div class="footer-column">
            <h3 class="column-title">关于我们</h3>
            <ul class="footer-links">
              <li><a href="#">公司介绍</a></li>
              <li><a href="#">团队成员</a></li>
              <li><a href="#">合作伙伴</a></li>
              <li><a href="#">成功案例</a></li>
              <li><a href="#">帮助文档</a></li>
              <li><a href="#">白皮书</a></li>
            </ul>
          </div>
          
          <div class="footer-column">
            <h3 class="column-title">资源中心</h3>
            <ul class="footer-links">
              <li><a href="#">技术博客</a></li>
              <li><a href="#">案例研究</a></li>
              <li><a href="#">培训中心</a></li>
              <li><a href="#">招贤纳士</a></li>
              <li><a href="#">智能助手</a></li>
            </ul>
          </div>
          
          <div class="footer-column contact-column">
            <h3 class="column-title">联系我们</h3>
            <ul class="footer-links contact-links">
              <li>
                <i class="fas fa-map-marker-alt"></i>
                <span>湖南省长沙市岳麓区麓谷企业广场</span>
              </li>
              <li>
                <i class="fas fa-phone-alt"></i>
                <span>+86 0731-88888888</span>
              </li>
              <li>
                <i class="fas fa-envelope"></i>
                <span>contact@stringmotioncube.com</span>
              </li>
            </ul>
            
            <div class="subscription">
              <h3 class="column-title">订阅我们的资讯</h3>
              <div class="subscription-form">
                <input type="email" placeholder="您的邮箱地址" class="email-input">
                <button class="send-button">
                  <i class="fas fa-paper-plane"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <div class="footer-copyright">
          © {{ new Date().getFullYear() }} 弦动魔方科技 版权所有
        </div>
        
        <div class="footer-policies">
          <a href="#" class="policy-link">隐私政策</a>
          <a href="#" class="policy-link">使用条款</a>
          <a href="#" class="policy-link">Cookie 声明</a>
          <a href="https://beian.miit.gov.cn/" class="beian-link" target="_blank">粤ICP备2025387110号-1</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>

<style scoped>
.footer-section {
  background-color: #1a1833;
  color: #b3b3cc;
  padding: 4rem 0 2rem;
  position: relative;
  overflow: hidden;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 主内容区域 */
.footer-main {
  display: flex;
  gap: 4rem;
  margin-bottom: 3rem;
}

.footer-company {
  width: 25%;
}

.footer-logo {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.logo-square {
  width: 32px;
  height: 32px;
  background-color: #9d6efd;
  border-radius: 6px;
  margin-right: 0.75rem;
}

.footer-logo span {
  color: #fff;
  font-size: 1.25rem;
  font-weight: 600;
}

.company-intro {
  font-size: 0.875rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  color: rgba(255, 255, 255, 0.7);
}

.social-icons {
  display: flex;
  gap: 1rem;
}

.social-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #252240;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b3b3cc;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-icon:hover {
  background-color: #9d6efd;
  color: #fff;
  transform: translateY(-2px);
}

/* 链接区域 */
.footer-links-wrapper {
  display: flex;
  flex: 1;
  gap: 3rem;
}

.footer-column {
  flex: 1;
}

.contact-column {
  flex: 1.5;
}

.column-title {
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 1.25rem;
  position: relative;
  padding-bottom: 0.5rem;
}

.column-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 2rem;
  height: 2px;
  background-color: #9d6efd;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 0.75rem;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.2s ease;
}

.footer-links a:hover {
  color: #9d6efd;
}

/* 联系方式 */
.contact-links li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.contact-links i {
  color: #9d6efd;
  margin-right: 0.75rem;
  margin-top: 0.25rem;
}

.subscription {
  margin-top: 2rem;
}

.subscription-form {
  position: relative;
}

.email-input {
  width: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 2rem;
  padding: 0.75rem 1.25rem;
  color: #fff;
  font-size: 0.875rem;
}

.email-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.send-button {
  position: absolute;
  right: 5px;
  top: 5px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #9d6efd;
  border: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/* 底部版权区域 */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 0.875rem;
}

.footer-policies {
  display: flex;
  gap: 1.5rem;
}

.footer-policies a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: color 0.2s ease;
}

.footer-policies a:hover {
  color: #fff;
}

/* 响应式设计 */
@media screen and (max-width: 1200px) {
  .footer-main {
    flex-direction: column;
    gap: 3rem;
  }
  
  .footer-company {
    width: 100%;
    max-width: 500px;
  }
  
  .footer-links-wrapper {
    flex-wrap: wrap;
    gap: 2rem;
  }
  
  .footer-column {
    flex: 1 0 40%;
    min-width: 200px;
  }
  
  .contact-column {
    flex: 1 0 100%;
  }
}

@media screen and (max-width: 768px) {
  .footer-links-wrapper {
    flex-direction: column;
    gap: 2rem;
  }
  
  .footer-column {
    width: 100%;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .footer-policies {
    justify-content: center;
  }
}

@media screen and (max-width: 480px) {
  .footer-section {
    padding: 3rem 0 1.5rem;
  }
  
  .container {
    padding: 0 1rem;
  }
  
  .footer-policies {
    flex-direction: column;
    gap: 0.75rem;
  }
  
  .beian-link {
    margin-top: 0.5rem;
    display: block;
  }
}

.beian-link {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 0.85rem;
  transition: color 0.2s ease;
  margin-left: 0.5rem;
  display: inline-block;
}

.beian-link:hover {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: underline;
}
</style> 